import ReportsPage from './pages/Reports.page'

ReportsPage.path = '/reports';

export default {
  pages: {
    ReportsPage,
  }
};
